import {
  AfterViewChecked,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'sp-tab',
  template: `
    <div [class.hidden]="!active" class="tab-content">
      <ng-content></ng-content>
      <ng-container
        *ngIf="template"
        [ngTemplateOutlet]="template"
        [ngTemplateOutletContext]="{ data: dataContext }">
      </ng-container>
    </div>
  `,
  styleUrls: ['./tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabComponent implements AfterViewChecked {
  @Input() title: string;
  @Input() template: HTMLTemplateElement;
  @Input() dataContext: any;
  @Output() clickedTabEvent = new EventEmitter<boolean>();
  active: boolean;

  constructor(private cdr: ChangeDetectorRef) {}

  setDetectTimeout = setTimeout(() => {
    this.cdr.detectChanges();
    clearTimeout(undefined);
  }, 100);

  ngAfterViewChecked() {
    this.setDetectTimeout;
    this.cdr.detectChanges();
  }
}
